document.addEventListener('DOMContentLoaded', () => {
  // adjust bg 
  const bg = document.querySelector('.plm-bg');
  const header = document.querySelector('#header-component')
  if(bg) {
    bg.style.top = `${header.offsetHeight}px`;
  }
  // adjust bg 

  // product-list carousel
  const sliders = document.querySelectorAll('.plm-product-list--carousel');
  if (sliders.length) {
    sliders.forEach(slider => {
      new Splide(slider).mount();
    });
  }
  // product-list carousel

  // tab collection
  const tab_collections = document.querySelectorAll('.plm-tab-collection');
  if (tab_collections == null) return;
  tab_collections.forEach(tab_collection => {
    const tabs = tab_collection.querySelectorAll('.plm-tab-collection__tab');
    let active_tab = tab_collection.querySelector('.plm-tab-collection__tab[aria-expanded="true"]');
    let active_content = tab_collection.querySelector('.plm-tab-collection__content[aria-hidden="false"]');
    if (!tabs.length) return;
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        if (tab != active_tab) {
          active_tab.setAttribute('aria-expanded', false);
          active_content.setAttribute('aria-hidden', true);
          const tab_content = tab_collection.querySelector(`#${tab.getAttribute('aria-controls')}`);
          const isExpanded = tab.getAttribute('aria-expanded') === 'true';
          tab.setAttribute('aria-expanded', !isExpanded);
          tab_content.setAttribute('aria-hidden', isExpanded);
          active_tab = tab;
          active_content = tab_content;
        }
      });
    });
  });
  // tab collection

  // sort option
  const sort_options = document.querySelectorAll('.sorting-filter__option');
  sort_options.forEach(option => {
    const sort_placeholder = document.querySelector('.js-sort-placeholder');
    if(location.search.match(option.getAttribute('id'))) {
      sort_placeholder.textContent = option.textContent;
    }
  });
  // sort option

  // product thumbnail
  const product_thumbnail = document.querySelector('.slideshow-controls__thumbnails');
  if(product_thumbnail != null) {
    let active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
    const product_thumbnail_next = document.querySelector('.thumbnail-control-next');
    const product_thumbnail_previous = document.querySelector('.thumbnail-control-previous');
    function update_previous_next_button() {
      if(active_thumbnail == product_thumbnail.lastElementChild) {
        product_thumbnail_next.setAttribute('disabled', true);
      } else {
        product_thumbnail_next.removeAttribute('disabled');
      }
      if(active_thumbnail == product_thumbnail.firstElementChild) {
        product_thumbnail_previous.setAttribute('disabled', true);
      } else {
        product_thumbnail_previous.removeAttribute('disabled');
      }
      active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
    }
    update_previous_next_button();

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          update_previous_next_button();
        });
    });
    const config = {
        attributes: true,
        subtree: true
    };
    observer.observe(product_thumbnail, config);

    product_thumbnail_next.addEventListener('click', () => {
      if(active_thumbnail != product_thumbnail.lastElementChild) {
        active_thumbnail.nextElementSibling.click();
        active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
      }
    });
    product_thumbnail_previous.addEventListener('click', () => {
      if(active_thumbnail != product_thumbnail.firstElementChild) {
        active_thumbnail.previousElementSibling.click();
        active_thumbnail = product_thumbnail.querySelector('.slideshow-control[aria-selected="true"]');
      }
    });
  }
  // product thumbnail

  // accordion
  const accordions = document.querySelectorAll('.js-plm-accordion');
  if(accordions.length > 0) {
    accordions.forEach(accordion => {
      function accordion_activate(accordion) {
      const button = accordion.querySelector('.js-plm-accordion-button');
      const content = accordion.querySelector('.js-plm-accordion-content');
      button.addEventListener('click', () => {
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
        content.setAttribute('aria-hidden', isExpanded);
      });
    }
      if(accordion.classList.contains('accordion-active-mobile')) {
        if(window.innerWidth < 750) {
          accordion_activate(accordion);
        } else {
          accordion.querySelector('.plm-accordion-menu').removeAttribute('aria-hidden');
        }
      } else if(accordion.classList.contains('accordion-active-desktop')) {
        if(window.innerWidth >= 750) {
          accordion_activate(accordion);
        }
      } else {
        accordion_activate(accordion);
      }
    });
  }
  // accordion
  // accordion-menu
  // if(window.innerWidth < 750) {
  //   const accordion_menues = document.querySelectorAll('.plm-accordion__menu-item');
  //   if(accordion_menues.length > 0) {
  //     accordion_menues.forEach(item => {
  //       if(item.closest('.plm-accordion-container').classList.contains('accordion-disabled')) {
  //         return;
  //       }
  //       item.addEventListener('click', () => {
  //         const isExpanded = item.getAttribute('aria-expanded') === 'true';
  //         item.setAttribute('aria-expanded', !isExpanded);
  //         item.nextElementSibling.setAttribute('aria-hidden', isExpanded);
  //       });
  //     });
  //   }
  // }
  // accordion-menu

  // discount code
  function renderDiscountPrices(is_collection_page) {
    const cookie = document.cookie;
    if(cookie.match('discount_code=TEST')) {
      const subscription_caution = document.querySelector('.subscription-caution'); 
      if(subscription_caution != null) {
        subscription_caution.style.display = 'block';
      }
      const prices = document.querySelectorAll('product-price .price'); 
      if(prices != null) {
        prices.forEach((price)=>{
          if(is_collection_page) {
            if(price.closest('product-price').parentNode.querySelector('.discount-text') == null) {
              const discount_text = document.createElement('div');
              discount_text.classList.add('discount-text');
              discount_text.innerText = 'クーポンご利用で20%OFF!';
              price.closest('product-price').before(discount_text);
              const usual_price = price.innerText;
              
              const saved_price = Math.round(Number(price.innerText.replace(/\D/g, '')) * 1.0);
              const varies = price.innerText.match(/[~〜]/) ? '~' : '';
              price.innerText = '¥' + saved_price.toLocaleString() + varies;
              const s = document.createElement('s');
              s.classList.add('compare-at-price');
              s.innerText = usual_price;
              price.after(s);
            }
          } else {
            if(price.closest('product-price').parentNode.querySelector('.discount-text') == null) {
              const discount_text = document.createElement('div');
              discount_text.classList.add('discount-text');
              discount_text.innerText = 'クーポンご利用で20%OFF!';
              price.closest('product-price').before(discount_text);
            }
            const usual_price = price.innerText;
            
            const saved_price = Math.round(Number(price.innerText.replace(/\D/g, '')) * 1.0);
            const varies = price.innerText.match(/[~〜]/) ? '~' : '';
            price.innerText = '¥' + saved_price.toLocaleString() + varies;
            const s = document.createElement('s');
            s.classList.add('compare-at-price');
            s.innerText = usual_price;
            price.after(s);
          }
        });
      }
      // const mikawaya_prices = document.querySelectorAll('.mikawaya-discount-price'); 
      // if(mikawaya_prices != null) {
      //   mikawaya_prices.forEach((price)=>{
      //     const saved_price = Math.round(Number(price.innerText.replace(/\D/g, '')) * 1.0);
      //     price.innerText = '¥' + saved_price.toLocaleString();
      //   })
      // }
    }
  }
  renderDiscountPrices();

  function renderMikawayaPrices(mikawaya_prices) {
    mikawaya_prices.forEach((price)=>{
      if(price.dataset.discounted != price.innerText) {
        const saved_price = Math.round(Number(price.innerText.replace(/\D/g, '')) * 1.0);
        price.innerText = '¥' + saved_price.toLocaleString();
        price.dataset.discounted = '¥' + saved_price.toLocaleString();
      }
    });
  }

  const product_details = document.querySelector('.product-details');
  if(product_details != null) {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(async(mutation) => {
          const mikawaya_prices = document.querySelectorAll('.mikawaya-discount-price'); 
          if(mikawaya_prices != null) {
            await renderMikawayaPrices(mikawaya_prices);
          }
        });
    });
    const config = {
      attributes: true,
      subtree: true
    };
    observer.observe(product_details, config);
  }

  document.addEventListener('variant:update', ()=>{
    renderDiscountPrices();
  });

  // 無限スクロール対策
  const product_grid = document.querySelector('#ResultsList .product-grid');
  if(product_grid != null) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        console.log('mutation ditected');
        renderDiscountPrices(true);
      });
    });
    const config = {
      attributes: true,
      childList: true
    };
    observer.observe(product_grid, config);
  }
  // 無限スクロール対策
  // discount code
});